import { ROUTE_META_PARAMS } from '@/router/consts.js'

import { ACCESS_LEVEL_PERMISSION } from '@/composables/access-level-permissions/const.js'

import Merge from './merge.js'

export default {
  path: 'customers',
  name: 'customers-main',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL_PERMISSION]: ACCESS_LEVEL_PERMISSION.clientDetails,
    hintKey: 'hintFeatureClients',
    defaultSubroute: {
      name: 'customers',
    },
  },
  component: () => import('@/views/business/customers/index.vue'),
  children: [
    Merge,
    {
      path: 'create',
      name: 'customer-create',
      component: () => import('@/views/business/customers/edit.vue'),
    },
    {
      path: ':customerId',
      name: 'customer-details',
      component: () => import('@/views/business/customers/list.vue'),
    },
    {
      path: ':customerId/edit',
      name: 'customer-edit',
      component: () => import('@/views/business/customers/edit.vue'),
    },
    {
      path: ':customerId/history-therapy',
      name: 'customer-history-therapy',
      component: () => import('@/views/business/customers/history-therapy.vue'),
    },
    {
      path: '',
      name: 'customers',
      component: () => import('@/views/business/customers/list.vue'),
    },
  ],
}
